import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditPermissionModal = ({ show, handleClose, permission, handleSave }) => {
    const [updatedPermission, setUpdatedPermission] = useState(permission);

    useEffect(() => {
        setUpdatedPermission(permission);
    }, [permission]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const fieldValue = type === 'checkbox' ? checked : value;
        setUpdatedPermission(prevPermission => ({
            ...prevPermission,
            [name]: fieldValue,
        }));
    };

    const onSave = () => {
        handleSave(updatedPermission); // Appeler handleSave du parent avec la Permission mise à jour
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modifier la permission</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formPermissionName">
                        <Form.Label>Nom de la permission</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={updatedPermission.nom || ''}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formPermissionDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            name="description"
                            value={updatedPermission.description || ''}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <br/>
                    <Form.Group controlId="formPermissionActive">
                        <Form.Check
                            type="checkbox"
                            label="Activé"
                            name="active"
                            checked={updatedPermission.active || false}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditPermissionModal;
